import { getters } from "@/constants/state";

export default {
  [getters.NEWS_GETTER]: (state) => state.news,
};
